import ProfilePic from "../../../img/Hamza.jpg"
export const Data=[
{
    pic:ProfilePic,
    name:`Hamza Ashfaq`,
    age:19,
    experiance:"2 years",
    country:"Pakistan",
    location:"Lahore",
    email:"hamzaashfaq7866@gmail.com",
    phone:"+923114340230",
    freelance:"Available",
    downloadResume:"Download Resume",
    contact:"CONTACT ME"
}
]